import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { VideoDetailsService } from '@app/core/services/video-details.service';
import { WithdrawalProductType } from '@generated/generatedEntities';
import { TranslocoService } from '@jsverse/transloco'; // Import TranslocoService

@Component({
  selector: 'app-rebuild',
  templateUrl: './rebuild.component.html',
  styleUrls: ['./rebuild.component.scss'],
})
export class RebuildComponent implements OnInit {
  private router = inject(Router);
  private videoDetailService = inject(VideoDetailsService);
  private translocoService = inject(TranslocoService);

  @Input() isAuthenticated!: boolean;
  @Input() hasRebuildCosts!: boolean;
  @Output() openBillingModal: EventEmitter<WithdrawalProductType> = new EventEmitter();

  isGerman = false;

  ngOnInit(): void {
    this.isGerman = this.translocoService.getActiveLang() === 'de-CH';
    this.translocoService.langChanges$.subscribe((lang) => {
      this.isGerman = lang === 'de-CH';
    });
  }

  openBillingModalForRebuild() {
    this.openBillingModal.emit('REBUILD_COSTS');
  }

  goToRebuildForm() {
    this.router.navigate(['/rebuild-form/input']);
  }

  openVideoDialog(): void {
    this.videoDetailService.openVideoDialog('rebuild');
  }
}
